import { render, staticRenderFns } from "./BuyNowCartBtn.vue?vue&type=template&id=7aaf2726&scoped=true&"
import script from "./BuyNowCartBtn.vue?vue&type=script&lang=js&"
export * from "./BuyNowCartBtn.vue?vue&type=script&lang=js&"
import style0 from "./BuyNowCartBtn.vue?vue&type=style&index=0&id=7aaf2726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf2726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBottomNavigation,VCol,VContainer,VRow})
